import { register } from 'tmr/tmr/ngModuleRegistry'

import * as api from './api'
import * as epcReaderInterface from './epcReaderInterface'
import * as localStorage from './localStorage'
import * as paging from './paging'
import * as resourceAdmin from './resourceAdmin'
import * as routes from './routes'

export default register(
  'tmr.core.providers',
  api,
  epcReaderInterface,
  localStorage,
  paging,
  routes,
  resourceAdmin
)
